import React from 'react';
import { Link } from 'react-router-dom';
import { campaigns } from '../data/mockData';

const Campaigns = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="pt-32 pb-16 px-6 lg:px-12 bg-cream">
        <div className="container mx-auto text-center">
          <span className="block text-gold text-lg md:text-xl font-bold tracking-widest uppercase">
            TAKE ACTION
          </span>
          <h1 className="mt-6 font-cormorant text-5xl md:text-7xl text-navy hover-text-zoom">
            Campaigns
          </h1>
          <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
            Join the fight for Life, Faith, Family, and Freedom. Your voice is valuable.
          </p>
        </div>
      </section>

      {/* Campaigns Grid */}
      <section className="py-20 px-6 lg:px-12">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {campaigns.filter((campaign) => !campaign.hidden).map((campaign) => (
              <Link
                key={campaign.id}
                to={`/campaigns/${campaign.id}`}
                className="group"
              >
                <article className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                  {/* 16:9 Image */}
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={campaign.image}
                      alt={campaign.title}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <h2 className="font-cormorant text-2xl md:text-3xl text-navy mb-2 group-hover:text-gold transition-colors hover-text-zoom">
                      {campaign.title}
                    </h2>
                    <p className="text-gold text-sm font-bold tracking-wide uppercase mb-3">
                      {campaign.subtitle}
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                      {campaign.excerpt}
                    </p>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Campaigns;
